import { createReducer } from './util';
import * as actionTypes from '../typedefs/actionTypes';
import {
    AgentAcceptedAction,
    LocationSettingsFetchedAction,
    RealConvoStartedAction,
    ConvoDetailsFetchedAction,
} from '../typedefs/actions';
import { UsersState } from '../typedefs/store';
import { LocationSettingsTeam } from '../typedefs/api';

const initialState: UsersState = {};

const handlers = {
    [actionTypes.LOCATION_SETTINGS_FETCHED]: locationSettingsFetched,
    [actionTypes.SOCKET_EVENT_AGENT_ACCEPTED]: agentAccepted,
    [actionTypes.CONVO_DETAILS_FETCHED]: convoDetailsFetched,
};

function locationSettingsFetched(state: UsersState, action: LocationSettingsFetchedAction) {
    return {
        ...state,
        ...buildUsers(action.payload.settings.teams),
    };
}

/**
 * convert teams.user array into objects of users, then reduce to a single object containing all users from all teams
 */
function buildUsers(teams: LocationSettingsTeam[]) {
    return teams
        .map(team =>
            team.users.reduce((users, user) => {
                users[user.id] = {
                    id: user.id,
                    name: user.name,
                    firstName: user.firstName,
                    lastName: user.lastName,
                    avatar: user.avatar,
                    isOnline: user.isOnline,
                };
                return users;
            }, {}),
        )
        .reduce((acc, cur) => ({ ...acc, ...cur }), {});
}

function agentAccepted(state: UsersState, action: AgentAcceptedAction): UsersState {
    return {
        ...state,
        [action.payload.userId]: {
            id: action.payload.userId,
            firstName: action.payload.firstName,
            lastName: action.payload.lastName,
            name: `${action.payload.firstName} ${action.payload.lastName}`,
            avatar: action.payload.avatar,
            isOnline: true,
        },
    };
}

function convoDetailsFetched(state: UsersState, action: ConvoDetailsFetchedAction): UsersState {
    return {
        ...state,
        ...action.payload.conversation.involvedAgents.reduce((acc, agent) => {
            return {
                ...acc,
                [agent.id]: {
                    id: agent.id,
                    firstName: agent.firstName,
                    lastName: agent.lastName,
                    name: `${agent.firstName} ${agent.lastName}`,
                    avatar: agent.avatar,
                    isOnline: true,
                },
            };
        }, {}),
    };
}

export default createReducer(initialState, handlers);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/reducers/users.ts